import {createSlice} from '@reduxjs/toolkit'

const initialUser = () => {
    return {}
}

export const authSlice = createSlice({
    name: 'authentication',
    initialState: {
        userInfo: initialUser()
    },
    reducers: {
        handleLogin: (state, action) => {
            state.userInfo = action.payload
        },
        handleLogout: state => {
            state.userInfo = {}
        }
    }
})

export const {
    handleLogin,
    handleLogout
} = authSlice.actions

export default authSlice.reducer
